import { Injectable } from '@angular/core';
import { MessageToastService } from './message-toast.service';
import { ApiResponse } from 'src/app/api/api-response.model';
import { HttpApiError } from '@models/http-api-error.model';
import { MESSAGES } from '@constants-globals/messages';

@Injectable({
  providedIn: 'root',
})
export class ApiNotificationService {
  constructor(private toastService: MessageToastService) {}

  public processApiResponse<T>(response: ApiResponse<T>): void {
    const { type, listMessage } = response;

    if (!listMessage || listMessage.length === 0) return;

    switch (type.toLowerCase()) {
      case 'success':
      case 'info':
        this.toastService.info(listMessage);
        break;
      case 'warning':
        this.toastService.warning(listMessage);
        break;
      case 'error':
        this.toastService.error(listMessage);
        break;
      default:
        this.toastService.info(listMessage);
        break;
    }
  }

  public processHttpError(err: HttpApiError, defaultMessage: string = MESSAGES.AUTH.LOGIN_ERROR): void {
    const messages = err?.error?.listMessage || [];

    if (messages.length > 0) {
      this.toastService.error(messages);
    } else {
      this.toastService.error([defaultMessage]);
    }
  }
}